import { diag } from '@opentelemetry/api'
import stringifySafe from 'json-stringify-safe'

export const jsonToString = (json) => {
  try {
    return JSON.stringify(json)
  } catch (ex) {
    diag.debug(`Failed to stringify json. e = ${ex}`)
    return stringifySafe(json)
  }
}

export const stringToBoolean = (stringValue: string | undefined) => {
  switch (stringValue?.toLowerCase()?.trim()) {
    case 'true':
    case 'yes':
    case '1':
      return true

    case 'false':
    case 'no':
    case '0':
      return false

    default:
      return undefined
  }
}

export function isPlainObject(value: any): boolean {
  // Check if the value is null or not an object
  if (value === null || typeof value !== 'object') {
    return false
  }

  // Get the prototype of the value
  const proto = Object.getPrototypeOf(value)

  // Check if it's null (for Object.create(null)) or if it's the root Object.prototype
  if (proto === null) {
    return true
  }

  // Check if the constructor is Object and the prototype is Object.prototype
  const Ctor =
    Object.hasOwnProperty.call(proto, 'constructor') && proto.constructor
  return (
    typeof Ctor === 'function' &&
    Ctor instanceof Ctor &&
    Function.prototype.toString.call(Ctor) ===
      Function.prototype.toString.call(Object)
  )
}

export function isObject(value: any): boolean {
  const type = typeof value
  return value != null && (type === 'object' || type === 'function')
}

export function isString(value: unknown): value is string {
  return typeof value === 'string' || value instanceof String
}
